import axios from "axios";
import { showAlert } from "./alert";

export const listProduct = async (formUpdates) => {
  try {
    const res = await axios({
      method: "PATCH",
      url: `/api/v1/products/list/:${formUpdates.id}`,
      data: formUpdates,
    });
    if (res.data.status === "success") {
      showAlert("success", `Item Listed!`);
      window.setTimeout(() => {
        location.assign("/myQueue");
      }, 1000);
    }
  } catch (err) {
    showAlert("error", err.response.data.message);
  }
};

export const saveProduct = async (formUpdates) => {
  try {
    const res = await axios({
      method: "PATCH",
      url: `/api/v1/products/save/:${formUpdates.id}`,
      data: formUpdates,
    });
    if (res.data.status === "success") {
      showAlert("success", `Item Saved!`);
      window.setTimeout(() => {
        location.reload();
      }, 1000);
    }
  } catch (err) {
    showAlert("error", err.response.data.message);
  }
};

export const unlistProduct = async (productId) => {
  try {
    const res = await axios({
      method: "PATCH",
      url: `/api/v1/products/unList/:${productId}`,
    });
    if (res.data.status === "success") {
      showAlert("success", `Item Unlisted!`);
      window.setTimeout(() => {
        location.reload();
      }, 1000);
    }
  } catch (err) {
    showAlert("error", err.response.data.message);
  }
};

export const uploadProductImage = async (formData) => {
  try {
    const res = await axios({
      method: "POST",
      url: `/api/v1/products/upload/:${formData.get("product")}`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (res.data.status === "success") {
      showAlert("success", `Photo Added!`);
      window.setTimeout(() => {
        location.reload();
      }, 1000);
    }
  } catch (err) {
    showAlert("error", err.response.data.message);
  }
};

export const deleteProductImage = async (prodId, imageName) => {
  try {
    const res = await axios({
      method: "PATCH",
      url: `/api/v1/products/deleteImg/:${prodId}/:${imageName}`,
      data: imageName,
    });
    if (res.data.status === "success") {
      showAlert("success", `Photo Deleted!`);
      window.setTimeout(() => {
        location.reload();
      }, 1000);
    }
  } catch (err) {
    showAlert("error", err.response.data.message);
  }
};

export const markAsSold = async (productId) => {
  try {
    const res = await axios({
      method: "PATCH",
      url: `/api/v1/products/sold/:${productId}`,
    });
    if (res.data.status === "success") {
      showAlert("success", `Removed Item!`);
      window.setTimeout(() => {
        location.reload();
      }, 1000);
    }
  } catch (err) {
    showAlert("error", err.response.data.message);
  }
};
